App.controller('ZochHealthPzuwListCtrl', ['$scope', '$state', '$stateParams', 'zochaPzuwHealthInsuranceService', 'zochaNavigationService',
    function ($scope, $state, $stateParams, zochaPzuwHealthInsuranceService, zochaNavigationService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_healthInsurance';
    $scope.$emit('page', $scope.page);

    if ($scope.stateParams.user) {
        $scope.userId = $scope.stateParams.user.id;
        $scope.who = $scope.stateParams.user.person.firstName + ' ' + $scope.stateParams.user.person.lastName;
    } else {
        $scope.userId = '';
        $scope.who = '';
    }

    $scope.step = 'Zarządzaj deklaracjami - Ubezpieczenie zdrowotne TUW PZUW';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.dashboard';
    $scope.$emit('link', $scope.link);

    $scope.dictionary = {
        "ENTERED": "wprowadzony",
        "EXPIRED": "wygaszony",
        "DELETED": "usunięty",
        "READY": "zawarty",
        "ACTIVE": "aktywny",
        "CANCELED": "anulowany",
        "WITHDRAWN": "wystąpienie",
        "ENDED": "zakończony"
    }

    var page = 0;
    $scope.status = 'all';
    $scope.current = page;
    $scope.pageSize = 10;
    $scope.searchString = '';

    loadActivities(page);

    $scope.search = function () {
        loadActivities(0, $scope.status);
    };

    $scope.byStatus = function (status) {
        loadActivities(0, status);
    };

    $scope.pageChanged = function (page) {
        loadActivities(page, $scope.status);
        $scope.current = page;
    };

    $scope.loadAll = function () {
        $scope.userId = '';
        $scope.who = '';
        $scope.status = 'all';
        $scope.current = 0;
        $scope.searchString = '';
        loadActivities(0, 'all');
    };

    function loadActivities(page, status) {
        var criteria = {
            pageNumber: page,
            pageSize: $scope.pageSize,
            userId: $scope.userId,
            search: $scope.searchString,
            insurer: 'PZUW'
        };

        if ($scope.cantDeduct) {
            criteria.cantDeduct = $scope.cantDeduct;
        }

        if (status && status !== 'all') {
            criteria.status = status;
        }
        zochaPzuwHealthInsuranceService.getDeclarations(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.activities = data.data.data;
                for (var a = 0; a < $scope.activities.length; a++) {
                    $scope.activities[a].activeStatus = ($scope.activities[a].status === 'ACTIVE');
                    if ($scope.activities[a].rehabilitation) {
                        $scope.activities[a].benefit.name += ' + Rehabilitacja';
                        $scope.activities[a].benefit.summaryPrice += $scope.activities[a].benefit.rehabilitationPrice;
                    }
                    if ($scope.activities[a].seniors.length > 0) {
                        $scope.activities[a].benefit.name += ' + Komfort Senior';
                        $scope.activities[a].benefit.summaryPrice += $scope.activities[a].seniors.length * $scope.activities[a].benefit.seniorPrice;
                    }
                }
                $scope.numberOfPages = data.data.pages;
                console.log($scope.activities);
            }
        });
    }

    $scope.cantDeduct = false;
    $scope.filterCantDeduct = function () {
        loadActivities(0, $scope.status);
    };

    $scope.goToDeclarationDetails = function (value) {
        $state.go('root.home.zoch.healthPzuw.details', {package: value});
    };

    $scope.goToWorkerDetails = function (value) {
        zochaNavigationService.goToWorkerDetails(value.userId);
    };
}]);
